export const timesData = {
  All: {
    label: 'All',
    unit: 'all'
  },
  '24hours': {
    label: '24 hours',
    unit: 'hours',
    ms: 24 * 60 * 60 * 1000
  },
  '12hours': {
    label: '12 hours',
    unit: 'hours',
    ms: 12 * 60 * 60 * 1000
  },
  '8hours': {
    label: '8 hours',
    unit: 'hours',
    ms: 8 * 60 * 60 * 1000
  },
  '4hours': {
    label: '4 hours',
    unit: 'hours',
    ms: 4 * 60 * 60 * 1000
  },
  '2hours': {
    label: '2 hours',
    unit: 'hours',
    ms: 2 * 60 * 60 * 1000
  }
}

// const average = {
//   label: 'Average',
//   icon: '/assets/dashed-line.svg'
// }

// const critical = {
//   label: 'Critical',
//   icon: '/assets/critical.svg'
// }

export const tabOptions = {
  temperature: {
    name: 'TEMPERATURE',
    vital: 'temperature',
    value: null,
    unit: '˚ C',
    key: 'temperature',
    legends: {
      temperature: {
        label: 'Temperature',
        icon: '/assets/pulse-red.svg'
      }
      // average
    }
  },
  butane: {
    name: 'BUTANE',
    vital: 'butane',
    value: null,
    unit: 'ppm',
    key: 'butane',
    legends: {
      butane: {
        label: 'Butane',
        icon: '/assets/pulse-red.svg'
      }
      // average
    }
  },
  sulphurDioxide: {
    name: 'SULPHUR DIOXIDE',
    vital: 'sulphurDioxide',
    value: null,
    unit: 'ppm',
    key: 'sulphurDioxide',
    legends: {
      sulphurDioxide: {
        label: 'SulphurDioxide',
        icon: '/assets/pulse-red.svg'
      }
      // average
    }
  },
  carbonDioxide: {
    name: 'CARBON DIOXIDE',
    vital: 'carbonDioxide',
    value: null,
    unit: 'ppm',
    key: 'carbonDioxide',
    legends: {
      carbonDioxide: {
        label: 'CarbonDioxide',
        icon: '/assets/pulse-red.svg'
      }
      // average
    }
  }
}
